// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"MainContent___wavCD","loading":"loading___2Wmd8"};